import {
    DRIVER_REQUEST,
    DRIVER_ERROR,
    DRIVER_SUCCESS,
    DRIVER_params
} from "../actions/driver";
import { ORDERSLIST_REQUEST } from "../actions/ordersList";
import Vue from "vue";
import apiCalls from "utils/api";
import store from '../../store';

const state = {
    lang: localStorage.getItem("lang") || "nl",
    driverInfo: {},
    status: "",
};

const getters = {
    getDriver: state => state.driver,
    isDriverLoaded: state => !!state.driver
};

const actions = {
    [DRIVER_REQUEST]: ({ commit, dispatch }) => {
        commit(DRIVER_REQUEST);

        var userName = store.state.auth.login;
        var filter = [
            {
                Filters: [
                    {
                        name: 'UserName',
                        value: userName,
                        operator: '='
                    }
                ]
            }
        ];

        DRIVER_params.filter = JSON.stringify(filter);

        apiCalls.apiCall({ url: "get", method: "GET", params: DRIVER_params })
            .then(resp => {
                commit(DRIVER_SUCCESS, resp.data);

                dispatch(ORDERSLIST_REQUEST);
            })
            .catch(() => {
                commit(DRIVER_ERROR);
            });
    }
};

const mutations = {
    [DRIVER_REQUEST]: state => {
        state.status = "loading";
    },
    [DRIVER_SUCCESS]: (state, resp) => {
        state.status = "success";
        if (resp.data.length)
            state.driverInfo = resp.data[0];

        Vue.set(state, "driver", resp.data[0]);
    },
    [DRIVER_ERROR]: state => {
        state.status = "error";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
